import { stylesheet } from 'typestyle';
import { flexRoot, horizontal, wrap, vertical, centerCenter } from 'csstips';

import { linkBlueText, regularYellowText } from './general';

export default stylesheet({
  container: {
    ...flexRoot,
    ...horizontal,
    ...wrap,

    paddingBottom: 25,
    order: 6
  },
  header: {
    marginTop: 18,
    marginRight: 32,
    marginLeft: 32,

    '@media (min-width: 866px) and (max-width: 890px)': {
      marginLeft: 25,
      marginRight: 25
    },

    '@media (max-width: 865px)': {
      marginLeft: 20,
      marginRight: 20
    }
  },
  marketingText: {
    marginLeft: 32,
    marginRight: 32,
    position: 'relative',

    '@media (min-width: 866px) and (max-width: 890px)': {
      marginLeft: 25,
      marginRight: 25
    },

    '@media (max-width: 865px)': {
      marginLeft: 20,
      marginRight: 20
    }
  },
  collapsedMarketingText: {
    overflow: 'hidden',
    maxHeight: 44,
    float: 'left'
  },
  collapseMarketingButton: {
    float: 'right'
  },
  collapsedMarketingButton: {
    paddingLeft: 10,
    position: 'absolute',
    right: 0,
    bottom: 0,
    background: 'white'
  },
  item: {
    flex: '25%',
    maxWidth: '25%',
    padding: '100px 32px 0px 32px',

    $nest: {
      '&:nth-child(1)': {
        paddingTop: 30
      },
      '&:nth-child(2)': {
        paddingTop: 30
      },
      '&:nth-child(3)': {
        paddingTop: 30
      },
      '&:nth-child(4)': {
        paddingTop: 30
      }
    },

    '@media (min-width: 700px) and (max-width: 767px)': {
      paddingLeft: 20,
      paddingRight: 20
    },

    '@media (min-width: 400px) and (max-width: 699px)': {
      paddingLeft: 10,
      paddingRight: 10,
      flex: '33.3%',
      maxWidth: '33.3%',

      '&:nth-child(4)': {
        paddingTop: 100
      }
    },

    '@media (max-width: 399px)': {
      flex: '50%',
      maxWidth: '50%',

      '&:nth-child(3)': {
        paddingTop: 100
      },
      '&:nth-child(4)': {
        paddingTop: 100
      }
    }
  },
  itemImage: {
    width: '100%'
  },
  imageLink: {
    position: 'relative',
    display: 'inline-block'
  },
  favoriteLink: {
    position: 'absolute',
    bottom: 1,
    right: 1
  },
  itemDescription: {
    marginBottom: 0,
    lineHeight: '18px'
  },
  itemLink: {
    color: linkBlueText,
    textDecoration: 'none',
    fontSize: 14,

    $nest: {
      '&:hover': {
        color: linkBlueText,
        textDecoration: 'underline'
      }
    }
  },
  itemPrice: {
    color: regularYellowText,
    marginBottom: 0
  },
  loading: {
    ...flexRoot,
    ...vertical,
    ...centerCenter,

    height: 300,
    width: '100%',

    p: {
      marginTop: '1em'
    }
  },
  resultsCount: {
    marginTop: 20,
    marginLeft: 32,
    color: '#7f7f7f',

    '@media (min-width: 866px) and (max-width: 890px)': {
      marginLeft: 25
    },

    '@media (max-width: 865px)': {
      marginLeft: 20
    }
  }
});
